<template>
  <v-container class="pb-6" fluid>
    <v-row>
      <v-col class="d-flex justify-center">
        <v-btn
          v-for="platform in socialMedia"
          :color="color"
          :href="platform.url"
          :key="platform.type"
          target="_blank"
          :size="rewardsFormat ? 'x-large' : 'small'"
          icon
          :class="{ 'px-7': rewardsFormat }"
        >
          <img
            :src="getSocialIcon(platform.type)"
            :alt="`${platform.type} icon`"
            :width="rewardsFormat ? 40 : 25"
            :height="rewardsFormat ? 40 : 25"
          />
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "SocialMedia",
  computed: {
    ...mapGetters("store", { rewardsFormat: "rewardsFormat" }),
    ...mapState({
      socialMedia: (state) =>
        state.store.info.store_info.social_media?.filter(
          (platform) => platform.url,
        ),
    }),
  },
  props: { color: String },
  methods: {
    getSocialIcon(platformType) {
      try {
        return require(`@/assets/social/${platformType}.png`);
      } catch (e) {
        console.warn(`Icon not found for platform: ${platformType}`);
        return require(`@/assets/social/default.png`);
      }
    },
  },
};
</script>
